import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Bounce, Circ, Elastic, Expo, Linear, Sine, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch9_p06 } from "../../../layouts/ch9_p06/ch9_p06";

export class Chapter9Page6 extends AbstractStoryState implements ReturnType<typeof ch9_p06> {
    readonly bg = this.addChild(new SceneSprite());
    readonly lightBack = [
        this.addChild(SceneSprite.withPrefix("ch9_p06/")),
        this.addChild(SceneSprite.withPrefix("ch9_p06/")),
    ];
    readonly holly = this.addChild(new SceneSprite());
    readonly lightFront = [
        this.addChild(SceneSprite.withPrefix("ch9_p06/")),
        this.addChild(SceneSprite.withPrefix("ch9_p06/")),
    ];

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch9_p06/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch9_p06/"));

    readonly linesRight = this.addChild(SceneSprite.withPrefix("ch9_p06/"));
    readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch9_p06/"));

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch9_p06.call(this);
        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
        TweenLite.delayedCall(3, ()=>{
            this.gotoNextState({transition: "up"});
        });
    }
}